import React from 'react';
import { PrivateRoute } from '@/components/HasRights/HasRights';
import { Permissions } from '@/const/permissions';
import appRoutes from '@/configs/routes';
import PageCollections from '../../domains/Content/pages/Collections/PageCollections/PageCollections';
import PageCreateCollection from '../../domains/Content/pages/Collections/PageCreateCollection/PageCreateCollection';
import PageEditCollection from '../../domains/Content/pages/Collections/PageEditCollection/PageEditCollection';
import PageCollectionDetails from '../../domains/Content/pages/Collections/PageCollectionDetails/PageCollectionDetails';



export const collectionsRoutes = ({ urlPrefix = null }) => [
  {
    path: appRoutes.urlPageCollections({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.CONTENT.COLLECTIONS.LIST ]}>
        <PageCollections />
      </PrivateRoute>
    ),
  },
  {
    path: appRoutes.urlPageCollectionCreate({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.CONTENT.COLLECTIONS.CREATE ]}>
        <PageCreateCollection />
      </PrivateRoute>
    ),
  },
  {
    path: appRoutes.urlPageCollectionEdit({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.CONTENT.COLLECTIONS.EDIT ]}>
        <PageEditCollection />
      </PrivateRoute>
    ),
  },
  {
    path: appRoutes.urlPageCollectionDetails({ urlPrefix }),
    element: (
      <PrivateRoute allowedPermissions={[ Permissions.CONTENT.COLLECTIONS.VIEW ]}>
        <PageCollectionDetails />
      </PrivateRoute>
    ),
  },
];
